import React, { useEffect, useState } from 'react';
import Popup from './Popup';
import './styles.css';

function PopupPage({ popupTriggers, popups, ...rest }) {
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    const popup = popupTriggers?.[0]?.popup;
    setPopup(popup);
  }, [popupTriggers]);

  const closeModal = () => {
    setPopup(null);
  };

  return (
    <>{popup && <Popup popup={popup} closeModal={closeModal} {...rest} />}</>
  );
}

export default PopupPage;
window.__Components.PopupPage = PopupPage;
